import React from 'react';

class SimpleInput extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      value
    });
  }

  render () {

    const value = this.state.value;
    //console.log(this.state);
    //console.log(this.props);
    //console.log('----------');
      return (
          <input
            readOnly={this.props.readOnly}
            autoComplete="off"
            onChange={this.props.onChange || this.handleChange}
            className="box-input--input"
            placeholder={this.props.placeholder}
            type={this.props.type}
            value={value}
            name={this.props.name} />
      );
  }
};

export default SimpleInput;



// WEBPACK FOOTER //
// ./src/components/form/SimpleInput.js